<div class="card">
  <div class="card-content">
    <div class="portal-hero">
      <div class="portal-hero-icon">
        <i class="pi pi-user-minus"></i>
      </div>
      <h2 class="portal-hero-title">Staff Offboarding Portal</h2>
      <p class="portal-hero-subtitle">Manage employee offboarding, track exit tasks, and ensure a smooth transition process.</p>
    </div>

    <div class="portal-grid">
      <div class="portal-card portal-card--form" (click)="navigateToCollectionWithForm()">
        <div class="portal-card-icon">
          <i class="pi pi-file-edit"></i>
        </div>
        <div class="portal-card-text">
          <h3>New Offboarding</h3>
          <p>Submit a new offboarding request for an employee</p>
        </div>
        <i class="pi pi-arrow-right portal-card-arrow"></i>
      </div>

      <div class="portal-card portal-card--collection" (click)="navigateToCollection()">
        <div class="portal-card-icon">
          <i class="pi pi-list"></i>
        </div>
        <div class="portal-card-text">
          <h3>Offboarding Records</h3>
          <p>View all offboarding records and track department tasks</p>
        </div>
        <i class="pi pi-arrow-right portal-card-arrow"></i>
      </div>

      <div class="portal-card portal-card--tasks" (click)="navigateToTaskTemplates()">
        <div class="portal-card-icon">
          <i class="pi pi-list-check"></i>
        </div>
        <div class="portal-card-text">
          <h3>Offboarding Templates</h3>
          <p>Configure offboarding tasks, questionnaires, and department checklists</p>
        </div>
        <i class="pi pi-arrow-right portal-card-arrow"></i>
      </div>
    </div>
  </div>
</div>
